<template>
  <div class="portal-feature">
    <div class="portal-feature-toolbar">
      <router-link class="btn btn-ghost btn-sm" :to="backLink">{{ backLabel }}</router-link>
    </div>
    <section class="portal-feature-content">
      <router-view/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PortalFeatureView',
  computed: {
    backLink() {
      return {name: this.$route.meta.featureBack || 'portalServices', params: {lang: this.$route.params.lang || 'fa'}}
    },
    backLabel() {
      return this.$route.params.lang === 'en' ? 'Back' : 'بازگشت'
    },
  },
}
</script>
